// الكود الكامل مع زر تعديل الطلب + البوب أب المدمج والمحدث بشكل كامل حسب طلبك

import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Button,
  Link,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
   Stack, 
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase"; // إذا عندك storage.js، غير المسار حسب مشروعك
import { addDoc, collection as firestoreCollection } from "firebase/firestore";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useNavigate } from "react-router-dom";

import { db } from "./firebase";
import {
  collection,
  query,
  where,
  getDocs,
  Timestamp,
} from "firebase/firestore";
import { getDisplayStatus, getDisplayName } from "./utils/statusLabels";
import { apiFetch, API_BASE } from "./utils/apiClient";
import UploadPreview, { appendPickedFiles } from "./components/UploadPreview";
import { showBuiltIn } from "./utils/accountBuiltIns";
import PrintChoiceBadge from "./components/PrintChoiceBadge";

const MaysaDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("all");
  const [editingOrder, setEditingOrder] = useState(null);
  const [editName, setEditName] = useState("");
  const [editPrice, setEditPrice] = useState("");
  const [editNote, setEditNote] = useState("");
const [loading, setLoading] = useState(false);
const [previewFile, setPreviewFile] = useState(null);
const [negativeArchive, setNegativeArchive] = useState(false); // ✅ جديد
const [openCancelDialog, setOpenCancelDialog] = useState(false);
const [cancelReason, setCancelReason] = useState("");
const [orderToCancel, setOrderToCancel] = useState(null);
const [selectedOrder, setSelectedOrder] = useState(null);
const [reasonText, setReasonText] = useState("");
const [rejectionFlow, setRejectionFlow] = useState(""); 
const [archivedOrders, setArchivedOrders] = useState([]);
const getDate = (t) => {
  if (!t) return null;

  if (typeof t.toDate === "function") {
    return t.toDate();
  }

  if (t instanceof Date) {
    return t;
  }

  if (t.seconds) {
    return new Date(t.seconds * 1000);
  }

  return new Date(t);
};

const getTime = (t) => {
  if (!t) return 0;

  if (typeof t.toMillis === "function") {
    return t.toMillis();
  }

  if (t instanceof Date) {
    return t.getTime();
  }

  if (t.seconds) {
    return t.seconds * 1000;
  }

  return new Date(t).getTime() || 0;
};
const dashboardBoxStyle = {
  height: 65,
  borderRadius: 2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  fontWeight: 500,
  fontSize: "13px",
  color: "#fff",
  cursor: "pointer",
  boxShadow: 1,
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: 3,
  },
};
const [savingFeedback, setSavingFeedback] = useState(false);
const [isEditingFeedback, setIsEditingFeedback] = useState(false);
const [existingFeedbackImages, setExistingFeedbackImages] = useState([]);
const handleCancelOrder = async () => {
  if (!orderToCancel || !cancelReason.trim()) return;

  try {
    const res = await apiFetch(
      `${API_BASE}/orders/${orderToCancel.id}/cancel-internal-delay`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ rejectionReason: cancelReason }),
      }
    );

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.error || "فشل إلغاء الطلب");
    }

    setOpenCancelDialog(false);
    setCancelReason("");
    setOrderToCancel(null);
    fetchOrders();
  } catch (err) {
    console.error("خطأ أثناء إلغاء الطلب:", err);
  }
};


const resetNegativeIssues = () => {
  setNegativeIssues({
    frame: { checked: false, note: "" },
    printing: { checked: false, note: "" },
    drawing: { checked: false, note: "" },
    designer: { checked: false, note: "" },
    transport: { checked: false, note: "" },
    employee: { checked: false, note: "" },
    delay: { checked: false, note: "" }, // ✅ أضف هذا
  });

};
const buildNegativeIssuesDetails = (orders) => {
  const rows = [];

  orders.forEach((order) => {
    if (order.feedback?.type !== "سلبي") return;

    const note = order.feedback?.note || "";
    const employee = order.employee || "غير محدد";

    const issuesMap = [
      { label: "مشكلة في الإطار", source: "الإطار" },
      { label: "مشكلة في الطباعة", source: "الطباعة" },
      { label: "مشكلة في الرسم", source: "الرسم" },
      { label: "مشكلة في المصمم", source: "المصمم" },
      { label: "مشكلة في شركة النقل", source: "شركة النقل" },
      { label: "مشكلة في الموظف المصمم", source: "الموظف" },
{ label: "تأخير في الوقت ", source: "الموظف" },
    ];

    issuesMap.forEach((issue) => {
      if (note.includes(issue.label)) {
        rows.push({
          orderId: order.id,
          customerName: order.customerName,
          employee,
          issue: issue.label,
          source: issue.source,
          price: Number(order.price) || 0,
        });
      }
    });
  });

  return rows;
};
const MockupImagesView = ({ order }) => {
  const images = order.mockupImages || [];

  if (!images.length) return null;

  return (
    <Box mt={2}>
      <Typography fontWeight="bold" sx={{ mb: 1 }}>
        🖼️ صور الموكاب المرسلة للزبون ({images.length})
      </Typography>

      <Box display="flex" gap={1} flexWrap="wrap">
        {images.map((url, index) => (
          <Box
            key={index}
            sx={{
              cursor: "pointer",
              border: "1px solid #ccc",
              borderRadius: 2,
              overflow: "hidden",
              width: 100,
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              "&:hover": { opacity: 0.8 },
            }}
            onClick={() => setPreviewFile({ url })}
          >
            <img
              src={url}
              alt={`mockup-${index}`}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
  const [feedbackOpen, setFeedbackOpen] = useState(false);
const [feedbackText, setFeedbackText] = useState("");
const [feedbackImages, setFeedbackImages] = useState([]);
const [currentFeedbackOrder, setCurrentFeedbackOrder] = useState(null);
const [openFeedbackDialog, setOpenFeedbackDialog] = useState(false);
const [feedbackType, setFeedbackType] = useState(""); // ✅ جديد
const [feedbackNote, setFeedbackNote] = useState("");
const [feedbackImage, setFeedbackImage] = useState(null);
const [selectedStatus, setSelectedStatus] = useState("الكل");
const [tasksOpen, setTasksOpen] = useState(false);
const [myTasks, setMyTasks] = useState([]);
const navigate = useNavigate();
const q = query(collection(db, "tasks"), where("employee", "==", "مياسة"));
// 🆕 خاص بصور التركيب فقط
const [installationFiles, setInstallationFiles] = useState([]);
const [openInstallationDialog, setOpenInstallationDialog] = useState(false);
const [currentInstallationOrder, setCurrentInstallationOrder] = useState(null);
// 🆕 فتح صور التركيب
const [openInstallationPreview, setOpenInstallationPreview] = useState(false);
const [previewFiles, setPreviewFiles] = useState([]);
const [uploadingInstallation, setUploadingInstallation] = useState(false);
// 🆕 مشاكل الفيدباك السلبي
const [negativeIssues, setNegativeIssues] = useState({
  frame: { checked: false, note: "" },
  printing: { checked: false, note: "" },
  drawing: { checked: false, note: "" },
  designer: { checked: false, note: "" },
  transport: { checked: false, note: "" },
  employee: { checked: false, note: "" },
    delay: { checked: false, note: "" }, // ✅ أضف هذا

});

const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");
const [searchTerm, setSearchTerm] = useState("");
const [selectedMonth, setSelectedMonth] = useState("");
useEffect(() => {
  fetchOrders();
  fetchArchivedOrders();
}, []);
const fetchArchivedOrders = async () => {
  const q = query(
    collection(db, "archivedOrders"),
    where("employee", "==", "مياسة")
  );

  const snapshot = await getDocs(q);
  const data = snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  setArchivedOrders(data);
};
const rejectedInternal = archivedOrders.filter(
  (o) => o.rejectionType === "internal_delay"
);

const rejectedLate = archivedOrders.filter(
  (o) => o.rejectionType === "late_delivery"
);

const rejectedDamaged = archivedOrders.filter(
  (o) => o.rejectionType === "damaged"
);


  const fetchOrders = async () => {
    const q = query(collection(db, "orders"), where("employee", "==", "مياسة"));
    const snapshot = await getDocs(q);
    const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    const sorted = data.sort(
      (a, b) => b.createdAt?.seconds - a.createdAt?.seconds
    );
    setOrders(sorted);
  };

  const handleOpenEdit = (order) => {
    setEditingOrder(order);
    setEditName(order.customerName);
    setEditPrice(order.price);
    setEditNote(order.note || "");
  };

const handleUpdate = async () => {
  if (!editingOrder) return;

  const res = await apiFetch(
    `${API_BASE}/orders/${editingOrder.id}/edit-and-return`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        customerName: editName,
        price: Number(editPrice),
        note: editNote,
        withDrawing: editingOrder.withDrawing,
        governorate: editingOrder.governorate,
      }),
    }
  );

  if (!res.ok) {
    console.error("خطأ أثناء تعديل الطلب:", await res.text().catch(() => ""));
    setEditingOrder(null);
    return;
  }

  setEditingOrder(null);
  fetchOrders();
};

 // ✅ فلترة حسب الحالة المختارة
const filteredOrders = orders.filter((order) => {
  if (order.excludedFromStats && order.rejectionType !== "damaged_fix_return") return false;

  // 🔎 فلترة البحث
  if (searchTerm) {
    if (!order.customerName?.toLowerCase().includes(searchTerm.toLowerCase())) {
      return false;
    }
  }

  // 📅 فلترة حسب الشهر المختار من بوكس المبيعات الشهرية
  if (selectedMonth) {
    const orderDate = getDate(order.createdAt);
    if (!orderDate) return false;

    const orderMonth = `${orderDate.getFullYear()}-${String(
      orderDate.getMonth() + 1
    ).padStart(2, "0")}`;

    if (orderMonth !== selectedMonth) return false;
  }

  // فلترة حسب التاريخ
  if (fromDate) {
    const orderDate = getDate(order.createdAt);
    if (orderDate < new Date(fromDate)) return false;
  }

  if (toDate) {
    const orderDate = getDate(order.createdAt);
    if (orderDate > new Date(toDate)) return false;
  }

  if (selectedStatus !== "الكل") {
    switch (selectedStatus) {
      case "عند يوسف":
        if (order.status !== "عند يوسف") return false;
        break;
      case "رسم":
        if (!order.status.includes("رسم")) return false;
        break;
      case "عند برهان":
        if (order.status !== "عند برهان") return false;
        break;
      case "فيدباك":
        if (order.status !== "feedbackRequired") return false;
        break;
      case "تم التوصيل":
        if (
          ![
            "تم التوصيل",
            "تركيب",
            "تم التركيب",
            "تم التوصيل (بعد الفيدباك)",
            "تم التركيب (بعد الفيدباك)",
          ].includes(order.status)
        )
          return false;
        break;
      default:
        break;
    }
  }

  return true;
});

// ✅ تقسيمات مثل فرح (بدون تغيير بروسيس)
// 1) قيد العمل
const inProgressSection = filteredOrders.filter(
  (order) =>
    ![
      "تم التوصيل",
      "تم التركيب",
      "تم التوصيل (بعد الفيدباك)",
      "تم التركيب (بعد الفيدباك)",
    ].includes(order.status) && order.status !== "feedbackRequired"
);

// 2) تم التوصيل (قبل الفيدباك)
const deliveredSection = filteredOrders.filter((order) =>
  ["تم التوصيل", "تم التركيب"].includes(order.status)
);

// 3) بانتظار الفيدباك
const feedbackSection = filteredOrders.filter(
  (order) => order.status === "feedbackRequired"
);

// 4) مكتملة (بعد الفيدباك)
const completedSection = filteredOrders.filter((order) =>
  ["تم التوصيل (بعد الفيدباك)", "تم التركيب (بعد الفيدباك)"].includes(order.status)
);

// ✅ نفس uniqueStatuses الخاص بفرح
const uniqueStatuses = [
  "الكل",
  "طلبات قيد العمل",
  "طلبات تم التوصيل",
  "طلبات فيدباك",
  
];

// ✅ نفس SectionHeader
const SectionHeader = ({ title, color }) => (
  <Paper
    sx={{
      p: 2,
      mt: 4,
      mb: 2,
      borderRadius: 3,
      backgroundColor: color,
      fontWeight: "bold",
    }}
  >
    <Typography variant="h6" fontWeight="bold">
      {title}
    </Typography>
  </Paper>
);

// ✅ الطلبات المرفوضة (نفس بروسيس المدير)
const negativeIssuesDetails = buildNegativeIssuesDetails(filteredOrders);
const ordersWithIssuesCount = [
  ...new Set(negativeIssuesDetails.map(row => row.orderId))
].length;


  const ordersToDisplay = filteredOrders.filter((order) => {
  if (filter === "inProgress") {
  return !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status);
}
if (filter === "completed") {
  return ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(order.status);
}

    return true;
  });

  const totalOrders = filteredOrders.length;
 const inProgressOrders = filteredOrders.filter(
  (o) => !["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
);

const completedOrders = filteredOrders.filter((o) =>
  ["تم التوصيل", "تركيب", "تم التركيب", "تم التوصيل (بعد الفيدباك)"].includes(o.status)
);

  const totalInProgress = inProgressOrders.length;
  const totalCompleted = completedOrders.length;

  const totalPrice = filteredOrders.reduce(
    (sum, o) => sum + (parseFloat(o.price) || 0),
    0
  );
  // 🔴 الطلبات المرفوضة الخاصة بجمانا فقط



  const priceInProgress = inProgressOrders.reduce(
    (sum, o) => sum + (parseFloat(o.price) || 0),
    0
  );
  const priceCompleted = completedOrders.reduce(
    (sum, o) => sum + (parseFloat(o.price) || 0),
    0
  );

  const monthlyStats = {};
  orders.forEach((order) => {
    const date = order.createdAt?.toDate();
    if (date) {
      const key = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;
      if (!monthlyStats[key]) {
        monthlyStats[key] = { count: 0, total: 0 };
      }
      monthlyStats[key].count += 1;
      monthlyStats[key].total += parseFloat(order.price) || 0;
    }
  });

  const monthlyArray = Object.entries(monthlyStats).sort(([a], [b]) =>
    b.localeCompare(a)
  );
  const monthlySales2026 = {};

filteredOrders.forEach((order) => {
  const date = order.createdAt?.toDate();
  if (!date) return;

  if (date.getFullYear() < 2026) return;

  const monthKey = `${date.getFullYear()}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}`;

 if (!monthlySales2026[monthKey]) {
  monthlySales2026[monthKey] = {
    total: 0,
    marketing: 0,
    marketingOrders: 0,
    orders: 0,
  };
}

  const price = Number(order.price) || 0;

  monthlySales2026[monthKey].total += price;
  monthlySales2026[monthKey].orders += 1;

const isMarketing =
  order.source === "ماركتنك" ||
  order.source === "marketing" ||
  order.saleAccount === "ماركتنك";

if (isMarketing) {
  monthlySales2026[monthKey].marketing += price;
  monthlySales2026[monthKey].marketingOrders += 1;
}
});

const monthlySalesArray = Object.entries(monthlySales2026).sort(
  ([a], [b]) => b.localeCompare(a)
);
const handleUploadInstallation = async () => {
  if (!currentInstallationOrder || installationFiles.length === 0) return;

  try {
    setUploadingInstallation(true); // 🔵 شغّل التحميل

    const uploadedFiles = [];

    for (const file of installationFiles) {
      const fileRef = ref(
        storage,
        `installation/${currentInstallationOrder.id}/${Date.now()}-${file.name}`
      );

      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);

      uploadedFiles.push({
        url,
        type: file.type.startsWith("video") ? "video" : "image",
        name: file.name,
      });
    }

   const res = await apiFetch(
  `${API_BASE}/orders/${currentInstallationOrder.id}/install`,
  {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ mode: "uploadFiles", installationFiles: uploadedFiles }),
  }
);
if (!res.ok) throw new Error(await res.text().catch(() => ""));


    setOpenInstallationDialog(false);
    setInstallationFiles([]);
    setCurrentInstallationOrder(null);
    fetchOrders();
  } catch (error) {
    console.error("❌ خطأ أثناء رفع صور التركيب:", error);
    alert("حدث خطأ أثناء رفع الملفات");
  } finally {
    setUploadingInstallation(false); // 🔵 وقف التحميل
  }
};


const handleSubmitFeedback = async () => {
  if (!currentFeedbackOrder) return;

  try {
    setSavingFeedback(true);

    // 1️⃣ رفع الصور الجديدة
    const newImagesUrls = [];

    for (const file of feedbackImages) {
      const fileRef = ref(
        storage,
        `feedbackImages/${currentFeedbackOrder.id}/${Date.now()}-${file.name}`
      );
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);
      newImagesUrls.push(url);
    }

    // 2️⃣ دمج الصور (القديمة بعد الحذف + الجديدة)
    const finalImages = [
      ...existingFeedbackImages,
      ...newImagesUrls,
    ];

    // finalFeedbackNote مُعرَّف هنا (قبل مسار الأرشفة أدناه اللي يستخدمه) بدل
    // موقعه القديم بعد هذا الشرط - كان يسبب ReferenceError حقيقي (temporal
    // dead zone) عند تفعيل الأرشفة
    let finalFeedbackNote = feedbackNote;

    // ✅ أرشفة فقط إذا الموظف اختار (رفض/رجّع اللوحة)
  if (!isEditingFeedback && feedbackType === "سلبي") {
  const orderId = currentFeedbackOrder.id;

  // 🧠 Phase 07-A: rejectionFlow لا يزال يقرّر "هل نؤرشف أصلاً" (only_feedback
  // = لا أرشفة)، لكن لم يعد يؤثر على شكل بيانات الأرشفة نفسها - قرار المنتج
  // الصريح جعل منطق Baneen (rejectionType="late_delivery" ثابت) هو المصدر
  // المعتمد للجميع. السيرفر يفرض هذي القيم دائماً بغض النظر عن rejectionFlow.

  // ✅ إذا فقط فيدباك → لا أرشفة
  if (rejectionFlow === "only_feedback") {
    // يكمل طبيعي بدون حذف
  } else {
    // 🔥 أرشفة
    const archiveRes = await apiFetch(`${API_BASE}/orders/${orderId}/archive-negative-feedback`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        feedback: {
          type: feedbackType,
          note: finalFeedbackNote,
          images: finalImages,
        },
      }),
    });
    if (!archiveRes.ok) {
      throw new Error(await archiveRes.text().catch(() => ""));
    }

    // تنظيف
    setRejectionFlow("");
    setExistingFeedbackImages([]);
    setFeedbackImages([]);
    setIsEditingFeedback(false);
    setOpenFeedbackDialog(false);
    setCurrentFeedbackOrder(null);
    resetNegativeIssues();

    fetchOrders();
    return;
  }
}
// 🧩 تجهيز تفاصيل الفيدباك السلبي كنص واحد
if (feedbackType === "سلبي") {
  const issuesText = Object.entries(negativeIssues)
    .filter(([_, v]) => v.checked)
    .map(([key, v]) => {
      const titles = {
        frame: "🖼️ مشكلة في الإطار",
        printing: "🖨️ مشكلة في الطباعة",
        drawing: "🎨 مشكلة في الرسم",
        designer: "📐 مشكلة في المصمم",
        transport: "🚚 مشكلة في شركة النقل",
        employee: "👤 مشكلة في الموظف المصمم",
      };
      return `- ${titles[key]}: ${v.note || "بدون تفاصيل"}`;
    })
    .join("\n");

  if (issuesText) {
    finalFeedbackNote = `${feedbackNote}\n\nتفاصيل المشاكل:\n${issuesText}`;
  }
}

    const updateData = {
      feedback: {
        type: feedbackType,
note: finalFeedbackNote,
        images: finalImages,
      },
    };

    // 3️⃣ إذا إضافة أول مرة فقط
    if (!isEditingFeedback) {
      updateData.feedbackRequired = false;

      let finalStatus = "تم التوصيل";
      let historyStatus = "تم التوصيل (بعد الفيدباك)";

      if (currentFeedbackOrder.completedSteps?.includes("تركيب")) {
        finalStatus = "تم التركيب";
        historyStatus = "تم التركيب (بعد الفيدباك)";
      }

      updateData.status = finalStatus;
      updateData.history = [
        ...(currentFeedbackOrder.history || []),
        {
          by: "مياسة",
          status: historyStatus,
          timestamp: Timestamp.now(),
        },
      ];
    }

   const res = await apiFetch(
  `${API_BASE}/orders/${currentFeedbackOrder.id}/feedback`,
  {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      feedback: {
        type: feedbackType,
        note: finalFeedbackNote,
        images: finalImages,
      },

      feedbackRequired: false,

      status: updateData.status,

      history: updateData.history,

      archive: feedbackType === "سلبي" && negativeArchive,
    }),
  }
);

const data = await res.json();

if (!res.ok) {
  alert(data.error || "حدث خطأ أثناء حفظ الفيدباك");
  return;
}

    // 4️⃣ تنظيف
    setExistingFeedbackImages([]);
    setFeedbackImages([]);
    setIsEditingFeedback(false);
    setOpenFeedbackDialog(false);
    setCurrentFeedbackOrder(null);
resetNegativeIssues(); // ✅ تفريغ مشاكل الفيدباك

    fetchOrders();
  } catch (err) {
    console.error("خطأ تعديل الفيدباك:", err);
  } finally {
    setSavingFeedback(false);
  }
};

// ✅ دالة لإعادة تسمية الحالات
const renameStatus = (status, order) => {
  if (!status) return "";

  return getDisplayStatus(status, order).replace(
    "feedbackRequired",
    " 📩 تم التوصيل_فيدباك"
  );
};
  // 📌 الحالات الممكنة للفلتر


  return (
    <Container sx={{ mt: 4 }} dir="rtl">
      <Typography variant="h4" align="right" fontWeight={600} sx={{ mb: 3 }}>
        لوحة مياسة
      </Typography>
<Grid container spacing={2} mb={4}>

  {showBuiltIn("box:siteVisit") && (
  <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}
      onClick={() => navigate("/site-visit")}
    >
      📍 زيارة موقع
    </Paper>
  </Grid>
  )}

  {showBuiltIn("box:myTasks") && (
  <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
      onClick={() => navigate("/MaysaTasks")}
    >
      📋 مهامي
    </Paper>
  </Grid>
  )}

  {showBuiltIn("box:directSale") && (
  <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}
      onClick={() => navigate("/archived-direct")}
    >
      🗂️ بيع مباشر
    </Paper>
  </Grid>
  )}

  {showBuiltIn("box:leads") && (
  <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
      onClick={() => navigate("/leads")}
    >
      📌 الزبائن المحتملين
    </Paper>
  </Grid>
  )}


 {showBuiltIn("box:drawingVideos") && (
 <Grid item xs={6} sm={4} md={2}>
      <Paper
       onClick={() => navigate("/story-videos")}
  sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
>🎬 فيديوات الرسم
      </Paper>
    </Grid>
 )}



  {showBuiltIn("box:todo") && (
  <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}
      onClick={() => navigate("/todo")}
    >
      📋 TO-DO
    </Paper>
  </Grid>
  )}

  {showBuiltIn("box:ordersAdmin") && (
  <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
      onClick={() =>
        window.open("https://admin-artika.netlify.app/login", "_blank")
      }
    >
    🗂️ ادارة الطلبات
    </Paper>
  </Grid>
  )}

  {showBuiltIn("box:canvasCost") && (
  <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#3f51b5" }}
      onClick={() => navigate("/canvas-cost")}
    >
      💰 سعر اللوحة
    </Paper>
  </Grid>
  )}

  {showBuiltIn("box:leaveRequest") && (
  <Grid item xs={6} sm={4} md={2}>
    <Paper
      sx={{ ...dashboardBoxStyle, backgroundColor: "#546e7a" }}
      onClick={() =>
        navigate("/leave-request?u=maysa@123&returnTo=/maysa")
      }
    >
      📝 طلب إجازة
    </Paper>
  </Grid>
  )}



</Grid>
<TextField
  label="🔍 ابحث عن اسم الزبون"
  fullWidth
  sx={{ mb: 3 }}
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>

{/* 🔎 فلترة حسب التاريخ */}
<Grid container spacing={2} mb={3}>
  <Grid item xs={12} sm={3}>
    <TextField
      label="من تاريخ"
      type="date"
      InputLabelProps={{ shrink: true }}
      fullWidth
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
    />
  </Grid>

  <Grid item xs={12} sm={3}>
    <TextField
      label="إلى تاريخ"
      type="date"
      InputLabelProps={{ shrink: true }}
      fullWidth
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
    />
    
  </Grid>

  
</Grid>



{/* 🎯 Target Reach Progress */}
{/* 🎯 Target Reach Progress (شهري) */}
{/* 🎯 Target Reach (شهري) */}
{/* 🎯 Target Reach صغير */}
<Box mt={4}>
  <Typography variant="h6" fontWeight="bold" mb={3}>
    📊 المبيعات الشهرية
  </Typography>

<Grid container spacing={3} alignItems="stretch">
    {monthlySalesArray.map(([month, data]) => (
   <Grid item xs={12} sm={6} md={4} lg={3} key={month} sx={{ display: "flex" }}>
 <Paper
  onClick={() => {
    setSelectedMonth(selectedMonth === month ? "" : month);
    setFromDate("");
    setToDate("");
    setSelectedStatus("الكل");
  }}
  sx={{
    p: 2,
    borderRadius: 3,
    textAlign: "center",
    boxShadow: selectedMonth === month ? 6 : 3,
    flex: 1,
    minHeight: 220,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: 0.8,
    cursor: "pointer",
    border: selectedMonth === month ? "3px solid #1976d2" : "2px solid transparent",
    transition: "0.25s",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: 6,
    },
  }}
>
  
         <Typography fontWeight="bold" fontSize={18} mb={1}>
            {month}
          </Typography>

<Typography sx={{ mt: 0.5 }}>
              💰 {data.total.toLocaleString()} د.ع
          </Typography>

        <Typography sx={{ color: "#ff6d00", fontWeight: "bold" }}>
  📣 ماركتنك: {data.marketing.toLocaleString()} د.ع ({data.marketingOrders} طلب)
</Typography>

          <Typography>
            📦 {data.orders} طلب
          </Typography>
          {(() => {
  const target = 15000000;
  const percentage = Math.min((data.total / target) * 100, 100);

  return (
    <>
      <Box sx={{ width: 85, height: 85, mx: "auto", mt: 1 }}>
        <CircularProgressbar
          value={percentage}
          text={`${Math.round(percentage)}%`}
          styles={buildStyles({
            textColor: "#1976d2",
            pathColor: "#1976d2",
            trailColor: "#eee",
          })}
        />
      </Box>

      <Typography fontSize={12} color="textSecondary">
        🎯 الهدف: {target.toLocaleString()} د.ع
      </Typography>
    </>
  );
})()}
        </Paper>
      </Grid>
    ))}
 
  </Grid>
</Box>

{selectedMonth && (
  <Paper
    sx={{
      mt: 3,
      mb: 3,
      p: 2,
      borderRadius: 3,
      backgroundColor: "#e3f2fd",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 2,
      flexWrap: "wrap",
    }}
  >
    <Typography fontWeight="bold">
      📅 الطلبات المعروضة حالياً لشهر: {selectedMonth}
    </Typography>

    <Button
      variant="outlined"
      color="primary"
      onClick={() => setSelectedMonth("")}
    >
      إلغاء فلتر الشهر
    </Button>
  </Paper>
)}
<Grid container spacing={2} mb={3} mt={4}>
  <Grid item xs={12} sm={3}>
    <Paper
      onClick={() =>
        setSelectedStatus(
          selectedStatus === "طلبات قيد العمل" ? "الكل" : "طلبات قيد العمل"
        )
      }
      sx={{
        p: 2,
        borderRadius: 3,
        textAlign: "center",
        boxShadow: 3,
        cursor: "pointer",
        border: selectedStatus === "طلبات قيد العمل" ? "3px solid #1976d2" : "none",
        transition: "0.3s",
        "&:hover": { transform: "scale(1.05)" },
      }}
    >
      <Typography fontWeight="bold">طلبات قيد العمل</Typography>
      <Typography variant="h5">{inProgressSection.length}</Typography>
    </Paper>
  </Grid>

  <Grid item xs={12} sm={3}>
    <Paper
      onClick={() =>
        setSelectedStatus(
          selectedStatus === "طلبات تم التوصيل" ? "الكل" : "طلبات تم التوصيل"
        )
      }
      sx={{
        p: 2,
        borderRadius: 3,
        textAlign: "center",
        boxShadow: 3,
        cursor: "pointer",
        border: selectedStatus === "طلبات تم التوصيل" ? "3px solid orange" : "none",
        transition: "0.3s",
        "&:hover": { transform: "scale(1.05)" },
      }}
    >
      <Typography fontWeight="bold">طلبات   مكتملة</Typography>
      <Typography variant="h5">{deliveredSection.length}</Typography>
    </Paper>
  </Grid>

  <Grid item xs={12} sm={3}>
    <Paper
      onClick={() =>
        setSelectedStatus(
          selectedStatus === "طلبات فيدباك" ? "الكل" : "طلبات فيدباك"
        )
      }
      sx={{
        p: 2,
        borderRadius: 3,
        textAlign: "center",
        boxShadow: 3,
        cursor: "pointer",
        backgroundColor: "#e8f5e9",
        border: selectedStatus === "طلبات فيدباك" ? "3px solid green" : "none",
        transition: "0.3s",
        "&:hover": { transform: "scale(1.05)" },
      }}
    >
      <Typography fontWeight="bold">طلبات فيدباك</Typography>
      <Typography variant="h5">{feedbackSection.length}</Typography>
    </Paper>
  </Grid>

 
</Grid>
    <Grid container spacing={2} mb={3} dir="rtl">
  <Grid item xs={12} sm={3}>
    <TextField
      select
      label="الحالة"
      fullWidth
      value={selectedStatus}
      onChange={(e) => setSelectedStatus(e.target.value)}
      SelectProps={{ native: true }}
    >
      {uniqueStatuses.map((s, i) => (
        <option key={i} value={s}>
          {getDisplayStatus(s)}
        </option>
      ))}
    </TextField>
  </Grid>
</Grid>
<Accordion sx={{ width: "100%", mb: 2 }}>
  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
    <Typography fontWeight="bold">
      🚫 الطلبات المرفوضة
    </Typography>
  </AccordionSummary>

  <AccordionDetails>

    {/* 1️⃣ ملغية داخلياً */}
    <Typography fontWeight="bold" color="error">
      1️⃣ ملغية بسبب تأخير داخلي ({rejectedInternal.length})
    </Typography>

    {rejectedInternal.map((order) => (
      <Paper key={order.id} sx={{ p: 2, mb: 1 }}>
        <Typography>📦 {order.customerName}</Typography>
        <Typography>💰 {Number(order.price).toLocaleString()} د.ع</Typography>
        <Typography>📝 السبب: {order.rejectionReason}</Typography>
      </Paper>
    ))}

    <Divider sx={{ my: 2 }} />

    {/* 2️⃣ وصلت متأخرة */}
    <Typography fontWeight="bold" color="error">
      2️⃣ وصلت متأخرة ورفضها الزبون ({rejectedLate.length})
    </Typography>

    {rejectedLate.map((order) => (
      <Paper key={order.id} sx={{ p: 2, mb: 1 }}>
        <Typography>📦 {order.customerName}</Typography>
        <Typography>💰 {Number(order.price).toLocaleString()} د.ع</Typography>
        <Typography>📩 ملاحظات: {order.feedback?.note}</Typography>
      </Paper>
    ))}

    <Divider sx={{ my: 2 }} />

    {/* 3️⃣ متضررة */}
    <Typography fontWeight="bold" color="error">
      3️⃣ متضررة ورفضها الزبون ({rejectedDamaged.length})
    </Typography>

    {rejectedDamaged.map((order) => (
      <Paper key={order.id} sx={{ p: 2, mb: 1 }}>
        <Typography>📦 {order.customerName}</Typography>
        <Typography>💰 {Number(order.price).toLocaleString()} د.ع</Typography>
      </Paper>
    ))}

  </AccordionDetails>
</Accordion>


      
      {/* عرض الطلبات */}
{(selectedStatus === "الكل" || selectedStatus === "طلبات قيد العمل") 
  && inProgressSection.length > 0 && (  <>
    <SectionHeader
      title={`🔵 طلبات قيد العمل (${inProgressSection.length})`}
      color="#e3f2fd"
    />
{inProgressSection.map((order) => {
  // نفس كود عرض الطلب (Accordion)

   
        const createdAt = getDate(order.createdAt);
        const now = new Date();
        const diffMs = now - createdAt;
        const diffHours = diffMs / (1000 * 60 * 60);
        return (
          <Accordion key={order.id} sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
           <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem", width: "100%" }}>
  الاسم: {order.customerName} | الحالة:{" "}
{order.status === "عند برهان" && order.completedSteps?.length > 0
  ? renameStatus(`عند برهان - ${order.completedSteps[order.completedSteps.length - 1]}`)
  : renameStatus(order.status, order)}
<PrintChoiceBadge order={order} />

  {order.drawingStatus && ` | 🎨 حالة الرسم: ${order.drawingStatus}`} 
  | المحافظة: {order.governorate} | السعر: {Number(order.price).toLocaleString()} د.ع
  | 🧩 عدد اللوحات: {order.boardsCount || "—"}
  {order.withDrawing && (
    <> | 🎨 عدد لوحات الرسم: {order.drawingBoardsCount || "—"}</>
  )}

</Typography>


            </AccordionSummary>
            <AccordionDetails>
              <Typography gutterBottom>
                الرابط: <Link href={order.https} target="_blank">فتح</Link>
              </Typography>
              {order.status === "عند يوسف" && (
  <Button
    variant="contained"
    color="error"
    sx={{ mt: 2, mr: 1 }}
    onClick={() => {
      setOrderToCancel(order);
      setOpenCancelDialog(true);
    }}
  >
    ❌ إلغاء الطلب
  </Button>
)}

              {order.note && <Typography gutterBottom>الملاحظات: {order.note}</Typography>}
              {order.source && <Typography gutterBottom>مصدر الطلب: {order.source}</Typography>}
              <MockupImagesView order={order} />
{/* 🎥 عرض الفيديوهات المرفوعة من حليمة */}
{order.videoLinks && order.videoLinks.length > 0 ? (
  <Box sx={{ mt: 1 }}>
    <Typography gutterBottom sx={{ fontWeight: "bold" }}>
      🎥 فيديوهات الرسم ({order.videoLinks.length})
    </Typography>
    {order.videoLinks.map((url, index) => (
      <Box key={index} sx={{ mb: 1 }}>
        <Link href={url} target="_blank" rel="noopener">
          ▶️ مشاهدة الفيديو {index + 1}
        </Link>
      </Box>
    ))}
  </Box>
) : order.driveLink ? (
  <Typography gutterBottom>
    🎥 رابط الرسم:{" "}
    <Link href={order.driveLink} target="_blank" rel="noopener">
      فتح الرابط
    </Link>
  </Typography>
) : null}

{/* 🖼️ عرض صور التركيب */}
{order.installationFiles && order.installationFiles.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">📷 صور / فيديوهات التركيب:</Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {order.installationFiles.map((f, i) =>
        f.type === "image" ? (
          <Box
            key={i}
            sx={{
              cursor: "pointer",
              border: "1px solid #ccc",
              borderRadius: 2,
              overflow: "hidden",
              width: 100,
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              "&:hover": { opacity: 0.8 },
            }}
            onClick={() => setPreviewFile(f)}
          >
            <img
              src={f.url}
              alt="installation"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ) : (
          <Button
            key={i}
            variant="outlined"
            size="small"
            onClick={() => window.open(f.url, "_blank")}
          >
            🎥 فيديو {i + 1}
          </Button>
        )
      )}
    </Box>
  </Box>
)}


{order.status === "feedbackRequired" && (() => {
 const lastFeedbackStep =
  order.history?.find(h => h.status === "feedbackRequired") || {
    timestamp: order.startTime || order.createdAt,
  };


const feedbackTime = getDate(lastFeedbackStep?.timestamp);
  const now = new Date();
 
  // تحقق من مرور 24 ساعة \\ 24 * 60 * 60 * 1000 \\  24 * 60 * 60 * 1000

const canShowFeedback =
  feedbackTime && now - feedbackTime >=1 * 60 * 1000;

console.log("🕓 feedbackTime:", feedbackTime?.toLocaleString());
console.log("🕓 now:", now.toLocaleString());
console.log("⏱ الفرق بالساعات:", (now - feedbackTime) / (1000 * 60 * 60));


  return canShowFeedback ? (
    <Button
      variant="contained"
      color="secondary"
      sx={{ mt: 2 }}
    onClick={() => {
        resetNegativeIssues(); // ✅ مهم جدًا
  setCurrentFeedbackOrder(order);
  setFeedbackType(order.feedback?.type || "");
  setFeedbackNote(order.feedback?.note || "");
  setFeedbackImages([]); // صور جديدة
  setExistingFeedbackImages(order.feedback?.images || []); // صور قديمة
  setIsEditingFeedback(!!order.feedback); // إذا موجود فيدباك = تعديل
  setOpenFeedbackDialog(true);
}}

    >
      📩 فيدباك الزبون
    </Button>
  ) : null;
})()}


              {diffHours <= 1 && (
                <Button variant="outlined" sx={{ mt: 2 }} onClick={() => handleOpenEdit(order)}>
                  ✏️ تعديل الطلب
                </Button>
              )}
              {/* 📷 زر رفع صور التركيب */}
{(
  order.status === "تركيب" ||
  order.status === "بانتظار تصوير التركيب" ||
  order.status?.includes("تركيب")
) && (
  <Box mt={2}>
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        setCurrentInstallationOrder(order);
        setInstallationFiles([]);
        setOpenInstallationDialog(true);
      }}
    >
      📷 رفع صور التركيب
    </Button>
  </Box>
)}


              <Divider sx={{ my: 2 }} />
              <Typography gutterBottom>سجل الحالة:</Typography>

              {/* فيدباك الزبون (إذا كان موجود) */}
{order.feedback && (
  <Box mt={2}>
    <Typography variant="h6" color="primary">
      📩 فيدباك الزبون:
    </Typography>

    <Typography>
      النوع: <strong>{order.feedback.type}</strong>
    </Typography>

    <Typography>
      الملاحظة: {order.feedback.note}
    </Typography>

  

    {/* 🖼️🖼️ عرض الصور المتعددة */}
    {order.feedback.images && order.feedback.images.length > 0 && (
      <Box mt={2}>
        <Typography fontWeight="bold">
          📷 صور الفيدباك ({order.feedback.images.length})
        </Typography>

        <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
          {order.feedback.images.map((url, index) => (
            <Box
              key={index}
              sx={{
                cursor: "pointer",
                border: "1px solid #ccc",
                borderRadius: 2,
                overflow: "hidden",
                width: 100,
                height: 100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f5f5f5",
                "&:hover": { opacity: 0.8 },
              }}
              onClick={() =>
                setPreviewFile({ url })
              }
            >
              <img
                src={url}
                alt={`feedback-${index}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Box>
        <Button
  variant="outlined"
  size="small"
  sx={{ mt: 2 }}
  onClick={() => {
    setCurrentFeedbackOrder(order);
    setFeedbackType(order.feedback.type);
    setFeedbackNote(order.feedback.note);
    setFeedbackImage(null);
    setFeedbackImages([]);
    setIsEditingFeedback(true);
    setOpenFeedbackDialog(true);
  }}
>
  ✏️ تعديل الفيدباك
</Button>

      </Box>
    )}
  </Box>
)}


              <Box display="flex" flexDirection="column" gap={1}>
                {(() => {
                  const historyList = [...(order.history || [])].sort((a, b) => getTime(b.timestamp) - getTime(a.timestamp));
                  const validTimes = historyList.map((h) => getTime(h.timestamp)).filter((t) => t > 0);
                  // ✅ نعرض "بواسطة" فقط لأول مرحلة (إرسال الطلب) - أقدم عنصر
                  // بالسجل زمنياً - وليس لبقية المراحل، بطلب المستخدم صراحة
                  const earliestTime = validTimes.length ? Math.min(...validTimes) : null;
                  return historyList.map((h, idx) => {
  const ts = getDate(h.timestamp);
                  const timestamp = ts ? `${ts.getFullYear()}-${String(ts.getMonth() + 1).padStart(2, "0")}-${String(ts.getDate()).padStart(2, "0")} ${String(ts.getHours()).padStart(2, "0")}:${String(ts.getMinutes()).padStart(2, "0")}` : "—";
                  const isFirstStage = earliestTime !== null && getTime(h.timestamp) === earliestTime;
                  return (
                    <Paper key={idx} sx={{ p: 1.5, backgroundColor: "#f9f9f9" }}>
<Typography variant="body2"><strong>الحالة:</strong> {renameStatus(h.status, order)}</Typography>
                      {isFirstStage && (
                        <Typography variant="body2"><strong>بواسطة:</strong> {getDisplayName(h.by || h.updatedBy || "غير معروف")}</Typography>
                      )}
                      <Typography variant="body2"><strong>الوقت:</strong> {timestamp}</Typography>
                    </Paper>
                  );
                  });
                })()}
              </Box>
 
            </AccordionDetails>
          </Accordion>
        );

      })}
  </>
)}

     {/* عرض الطلبات */}
{(selectedStatus === "الكل" || selectedStatus === "طلبات تم التوصيل") 
  && deliveredSection.length > 0 && (  <>
    <SectionHeader
      title={`🟡 طلبات تم التوصيل (${deliveredSection.length})`}
      color="#fff8e1"
    />

{deliveredSection.map((order) =>  {
  // نفس كود عرض الطلب (Accordion)

   
        const createdAt = getDate(order.createdAt);
        const now = new Date();
        const diffMs = now - createdAt;
        const diffHours = diffMs / (1000 * 60 * 60);
        return (
          <Accordion key={order.id} sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
           <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem", width: "100%" }}>
  الاسم: {order.customerName} | الحالة:{" "}
{order.status === "عند برهان" && order.completedSteps?.length > 0
  ? renameStatus(`عند برهان - ${order.completedSteps[order.completedSteps.length - 1]}`)
  : renameStatus(order.status, order)}
<PrintChoiceBadge order={order} />

  {order.drawingStatus && ` | 🎨 حالة الرسم: ${order.drawingStatus}`} 
  | المحافظة: {order.governorate} | السعر: {Number(order.price).toLocaleString()} د.ع
  | 🧩 عدد اللوحات: {order.boardsCount || "—"}
  {order.withDrawing && (
    <> | 🎨 عدد لوحات الرسم: {order.drawingBoardsCount || "—"}</>
  )}

</Typography>


            </AccordionSummary>
            <AccordionDetails>
              <Typography gutterBottom>
                الرابط: <Link href={order.https} target="_blank">فتح</Link>
              </Typography>
              {order.status === "عند يوسف" && (
  <Button
    variant="contained"
    color="error"
    sx={{ mt: 2, mr: 1 }}
    onClick={() => {
      setOrderToCancel(order);
      setOpenCancelDialog(true);
    }}
  >
    ❌ إلغاء الطلب
  </Button>
)}

              {order.note && <Typography gutterBottom>الملاحظات: {order.note}</Typography>}
              {order.source && <Typography gutterBottom>مصدر الطلب: {order.source}</Typography>}
              <MockupImagesView order={order} />
{/* 🎥 عرض الفيديوهات المرفوعة من حليمة */}
{order.videoLinks && order.videoLinks.length > 0 ? (
  <Box sx={{ mt: 1 }}>
    <Typography gutterBottom sx={{ fontWeight: "bold" }}>
      🎥 فيديوهات الرسم ({order.videoLinks.length})
    </Typography>
    {order.videoLinks.map((url, index) => (
      <Box key={index} sx={{ mb: 1 }}>
        <Link href={url} target="_blank" rel="noopener">
          ▶️ مشاهدة الفيديو {index + 1}
        </Link>
      </Box>
    ))}
  </Box>
) : order.driveLink ? (
  <Typography gutterBottom>
    🎥 رابط الرسم:{" "}
    <Link href={order.driveLink} target="_blank" rel="noopener">
      فتح الرابط
    </Link>
  </Typography>
) : null}

{/* 🖼️ عرض صور التركيب */}
{order.installationFiles && order.installationFiles.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">📷 صور / فيديوهات التركيب:</Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {order.installationFiles.map((f, i) =>
        f.type === "image" ? (
          <Box
            key={i}
            sx={{
              cursor: "pointer",
              border: "1px solid #ccc",
              borderRadius: 2,
              overflow: "hidden",
              width: 100,
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              "&:hover": { opacity: 0.8 },
            }}
            onClick={() => setPreviewFile(f)}
          >
            <img
              src={f.url}
              alt="installation"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ) : (
          <Button
            key={i}
            variant="outlined"
            size="small"
            onClick={() => window.open(f.url, "_blank")}
          >
            🎥 فيديو {i + 1}
          </Button>
        )
      )}
    </Box>
  </Box>
)}


{order.status === "feedbackRequired" && (() => {
 const lastFeedbackStep =
  order.history?.find(h => h.status === "feedbackRequired") || {
    timestamp: order.startTime || order.createdAt,
  };


const feedbackTime = getDate(lastFeedbackStep?.timestamp);
  const now = new Date();

  // تحقق من مرور 24 ساعة \\ 24 * 60 * 60 * 1000 \\  24 * 60 * 60 * 1000

const canShowFeedback =
  feedbackTime && now - feedbackTime >=1 * 60 * 1000;

console.log("🕓 feedbackTime:", feedbackTime?.toLocaleString());
console.log("🕓 now:", now.toLocaleString());
console.log("⏱ الفرق بالساعات:", (now - feedbackTime) / (1000 * 60 * 60));


  return canShowFeedback ? (
    <Button
      variant="contained"
      color="secondary"
      sx={{ mt: 2 }}
    onClick={() => {
        resetNegativeIssues(); // ✅ مهم جدًا
  setCurrentFeedbackOrder(order);
  setFeedbackType(order.feedback?.type || "");
  setFeedbackNote(order.feedback?.note || "");
  setFeedbackImages([]); // صور جديدة
  setExistingFeedbackImages(order.feedback?.images || []); // صور قديمة
  setIsEditingFeedback(!!order.feedback); // إذا موجود فيدباك = تعديل
  setOpenFeedbackDialog(true);
}}

    >
      📩 فيدباك الزبون
    </Button>
  ) : null;
})()}


              {diffHours <= 1 && (
                <Button variant="outlined" sx={{ mt: 2 }} onClick={() => handleOpenEdit(order)}>
                  ✏️ تعديل الطلب
                </Button>
              )}
              {/* 📷 زر رفع صور التركيب */}
{(
  order.status === "تركيب" ||
  order.status === "بانتظار تصوير التركيب" ||
  order.status?.includes("تركيب")
) && (
  <Box mt={2}>
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        setCurrentInstallationOrder(order);
        setInstallationFiles([]);
        setOpenInstallationDialog(true);
      }}
    >
      📷 رفع صور التركيب
    </Button>
  </Box>
)}


              <Divider sx={{ my: 2 }} />
              <Typography gutterBottom>سجل الحالة:</Typography>

              {/* فيدباك الزبون (إذا كان موجود) */}
{order.feedback && (
  <Box mt={2}>
    <Typography variant="h6" color="primary">
      📩 فيدباك الزبون:
    </Typography>

    <Typography>
      النوع: <strong>{order.feedback.type}</strong>
    </Typography>

    <Typography>
      الملاحظة: {order.feedback.note}
    </Typography>

  

    {/* 🖼️🖼️ عرض الصور المتعددة */}
    {order.feedback.images && order.feedback.images.length > 0 && (
      <Box mt={2}>
        <Typography fontWeight="bold">
          📷 صور الفيدباك ({order.feedback.images.length})
        </Typography>

        <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
          {order.feedback.images.map((url, index) => (
            <Box
              key={index}
              sx={{
                cursor: "pointer",
                border: "1px solid #ccc",
                borderRadius: 2,
                overflow: "hidden",
                width: 100,
                height: 100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f5f5f5",
                "&:hover": { opacity: 0.8 },
              }}
              onClick={() =>
                setPreviewFile({ url })
              }
            >
              <img
                src={url}
                alt={`feedback-${index}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Box>
        <Button
  variant="outlined"
  size="small"
  sx={{ mt: 2 }}
  onClick={() => {
    setCurrentFeedbackOrder(order);
    setFeedbackType(order.feedback.type);
    setFeedbackNote(order.feedback.note);
    setFeedbackImage(null);
    setFeedbackImages([]);
    setIsEditingFeedback(true);
    setOpenFeedbackDialog(true);
  }}
>
  ✏️ تعديل الفيدباك
</Button>

      </Box>
    )}
  </Box>
)}


              <Box display="flex" flexDirection="column" gap={1}>
                {(() => {
                  const historyList = [...(order.history || [])].sort((a, b) => getTime(b.timestamp) - getTime(a.timestamp));
                  const validTimes = historyList.map((h) => getTime(h.timestamp)).filter((t) => t > 0);
                  // ✅ نعرض "بواسطة" فقط لأول مرحلة (إرسال الطلب) - أقدم عنصر
                  // بالسجل زمنياً - وليس لبقية المراحل، بطلب المستخدم صراحة
                  const earliestTime = validTimes.length ? Math.min(...validTimes) : null;
                  return historyList.map((h, idx) => {
  const ts = getDate(h.timestamp);
                  const timestamp = ts ? `${ts.getFullYear()}-${String(ts.getMonth() + 1).padStart(2, "0")}-${String(ts.getDate()).padStart(2, "0")} ${String(ts.getHours()).padStart(2, "0")}:${String(ts.getMinutes()).padStart(2, "0")}` : "—";
                  const isFirstStage = earliestTime !== null && getTime(h.timestamp) === earliestTime;
                  return (
                    <Paper key={idx} sx={{ p: 1.5, backgroundColor: "#f9f9f9" }}>
<Typography variant="body2"><strong>الحالة:</strong> {renameStatus(h.status, order)}</Typography>
                      {isFirstStage && (
                        <Typography variant="body2"><strong>بواسطة:</strong> {getDisplayName(h.by || h.updatedBy || "غير معروف")}</Typography>
                      )}
                      <Typography variant="body2"><strong>الوقت:</strong> {timestamp}</Typography>
                    </Paper>
                  );
                  });
                })()}
              </Box>
 
            </AccordionDetails>
          </Accordion>
        );
      })}
  </>
)}

{(selectedStatus === "الكل" || selectedStatus === "طلبات فيدباك") 
  && feedbackSection.length > 0 && (  <>
    <SectionHeader
      title={`🟢 طلبات بانتظار الفيدباك (${feedbackSection.length})`}
      color="#e8f5e9"
    />

{feedbackSection.map((order) => {
  const createdAt = getDate(order.createdAt);
  const now = new Date();
  const diffMs = now - createdAt;
  const diffHours = diffMs / (1000 * 60 * 60);

  return (
    <Box
      key={order.id}
      sx={{
        backgroundColor: "#e8f5e9",
        borderRadius: 2,
        mb: 2,
      }}
    >
       <Accordion key={order.id} sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
           <Typography sx={{ fontWeight: "bold", fontSize: "0.9rem", width: "100%" }}>
  الاسم: {order.customerName} | الحالة:{" "}
{order.status === "عند برهان" && order.completedSteps?.length > 0
  ? renameStatus(`عند برهان - ${order.completedSteps[order.completedSteps.length - 1]}`)
  : renameStatus(order.status, order)}
<PrintChoiceBadge order={order} />

  {order.drawingStatus && ` | 🎨 حالة الرسم: ${order.drawingStatus}`} 
  | المحافظة: {order.governorate} | السعر: {Number(order.price).toLocaleString()} د.ع
  | 🧩 عدد اللوحات: {order.boardsCount || "—"}
  {order.withDrawing && (
    <> | 🎨 عدد لوحات الرسم: {order.drawingBoardsCount || "—"}</>
  )}

</Typography>


            </AccordionSummary>
            <AccordionDetails>
              <Typography gutterBottom>
                الرابط: <Link href={order.https} target="_blank">فتح</Link>
              </Typography>
              {order.status === "عند يوسف" && (
  <Button
    variant="contained"
    color="error"
    sx={{ mt: 2, mr: 1 }}
    onClick={() => {
      setOrderToCancel(order);
      setOpenCancelDialog(true);
    }}
  >
    ❌ إلغاء الطلب
  </Button>
)}

              {order.note && <Typography gutterBottom>الملاحظات: {order.note}</Typography>}
              {order.source && <Typography gutterBottom>مصدر الطلب: {order.source}</Typography>}
              <MockupImagesView order={order} />
{/* 🎥 عرض الفيديوهات المرفوعة من حليمة */}
{order.videoLinks && order.videoLinks.length > 0 ? (
  <Box sx={{ mt: 1 }}>
    <Typography gutterBottom sx={{ fontWeight: "bold" }}>
      🎥 فيديوهات الرسم ({order.videoLinks.length})
    </Typography>
    {order.videoLinks.map((url, index) => (
      <Box key={index} sx={{ mb: 1 }}>
        <Link href={url} target="_blank" rel="noopener">
          ▶️ مشاهدة الفيديو {index + 1}
        </Link>
      </Box>
    ))}
  </Box>
) : order.driveLink ? (
  <Typography gutterBottom>
    🎥 رابط الرسم:{" "}
    <Link href={order.driveLink} target="_blank" rel="noopener">
      فتح الرابط
    </Link>
  </Typography>
) : null}

{/* 🖼️ عرض صور التركيب */}
{order.installationFiles && order.installationFiles.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">📷 صور / فيديوهات التركيب:</Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {order.installationFiles.map((f, i) =>
        f.type === "image" ? (
          <Box
            key={i}
            sx={{
              cursor: "pointer",
              border: "1px solid #ccc",
              borderRadius: 2,
              overflow: "hidden",
              width: 100,
              height: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5",
              "&:hover": { opacity: 0.8 },
            }}
            onClick={() => setPreviewFile(f)}
          >
            <img
              src={f.url}
              alt="installation"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        ) : (
          <Button
            key={i}
            variant="outlined"
            size="small"
            onClick={() => window.open(f.url, "_blank")}
          >
            🎥 فيديو {i + 1}
          </Button>
        )
      )}
    </Box>
  </Box>
)}


{order.status === "feedbackRequired" && (() => {
 const lastFeedbackStep =
  order.history?.find(h => h.status === "feedbackRequired") || {
    timestamp: order.startTime || order.createdAt,
  };


const feedbackTime = getDate(lastFeedbackStep?.timestamp);
  const now = new Date();

  // تحقق من مرور 24 ساعة \\ 24 * 60 * 60 * 1000 \\  24 * 60 * 60 * 1000

const canShowFeedback =
  feedbackTime && now - feedbackTime >=1 * 60 * 1000;

console.log("🕓 feedbackTime:", feedbackTime?.toLocaleString());
console.log("🕓 now:", now.toLocaleString());
console.log("⏱ الفرق بالساعات:", (now - feedbackTime) / (1000 * 60 * 60));


  return canShowFeedback ? (
    <Button
      variant="contained"
      color="secondary"
      sx={{ mt: 2 }}
    onClick={() => {
        resetNegativeIssues(); // ✅ مهم جدًا
  setCurrentFeedbackOrder(order);
  setFeedbackType(order.feedback?.type || "");
  setFeedbackNote(order.feedback?.note || "");
  setFeedbackImages([]); // صور جديدة
  setExistingFeedbackImages(order.feedback?.images || []); // صور قديمة
  setIsEditingFeedback(!!order.feedback); // إذا موجود فيدباك = تعديل
  setOpenFeedbackDialog(true);
}}

    >
      📩 فيدباك الزبون
    </Button>
  ) : null;
})()}


              {diffHours <= 1 && (
                <Button variant="outlined" sx={{ mt: 2 }} onClick={() => handleOpenEdit(order)}>
                  ✏️ تعديل الطلب
                </Button>
              )}
              {/* 📷 زر رفع صور التركيب */}
{(
  order.status === "تركيب" ||
  order.status === "بانتظار تصوير التركيب" ||
  order.status?.includes("تركيب")
) && (
  <Box mt={2}>
    <Button
      variant="contained"
      color="primary"
      onClick={() => {
        setCurrentInstallationOrder(order);
        setInstallationFiles([]);
        setOpenInstallationDialog(true);
      }}
    >
      📷 رفع صور التركيب
    </Button>
  </Box>
)}


              <Divider sx={{ my: 2 }} />
              <Typography gutterBottom>سجل الحالة:</Typography>

              {/* فيدباك الزبون (إذا كان موجود) */}
{order.feedback && (
  <Box mt={2}>
    <Typography variant="h6" color="primary">
      📩 فيدباك الزبون:
    </Typography>

    <Typography>
      النوع: <strong>{order.feedback.type}</strong>
    </Typography>

    <Typography>
      الملاحظة: {order.feedback.note}
    </Typography>

  

    {/* 🖼️🖼️ عرض الصور المتعددة */}
    {order.feedback.images && order.feedback.images.length > 0 && (
      <Box mt={2}>
        <Typography fontWeight="bold">
          📷 صور الفيدباك ({order.feedback.images.length})
        </Typography>

        <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
          {order.feedback.images.map((url, index) => (
            <Box
              key={index}
              sx={{
                cursor: "pointer",
                border: "1px solid #ccc",
                borderRadius: 2,
                overflow: "hidden",
                width: 100,
                height: 100,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f5f5f5",
                "&:hover": { opacity: 0.8 },
              }}
              onClick={() =>
                setPreviewFile({ url })
              }
            >
              <img
                src={url}
                alt={`feedback-${index}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>
          ))}
        </Box>
        <Button
  variant="outlined"
  size="small"
  sx={{ mt: 2 }}
  onClick={() => {
    setCurrentFeedbackOrder(order);
    setFeedbackType(order.feedback.type);
    setFeedbackNote(order.feedback.note);
    setFeedbackImage(null);
    setFeedbackImages([]);
    setIsEditingFeedback(true);
    setOpenFeedbackDialog(true);
  }}
>
  ✏️ تعديل الفيدباك
</Button>

      </Box>
    )}
  </Box>
)}


              <Box display="flex" flexDirection="column" gap={1}>
                {(() => {
                  const historyList = [...(order.history || [])].sort((a, b) => getTime(b.timestamp) - getTime(a.timestamp));
                  const validTimes = historyList.map((h) => getTime(h.timestamp)).filter((t) => t > 0);
                  // ✅ نعرض "بواسطة" فقط لأول مرحلة (إرسال الطلب) - أقدم عنصر
                  // بالسجل زمنياً - وليس لبقية المراحل، بطلب المستخدم صراحة
                  const earliestTime = validTimes.length ? Math.min(...validTimes) : null;
                  return historyList.map((h, idx) => {
  const ts = getDate(h.timestamp);
                  const timestamp = ts ? `${ts.getFullYear()}-${String(ts.getMonth() + 1).padStart(2, "0")}-${String(ts.getDate()).padStart(2, "0")} ${String(ts.getHours()).padStart(2, "0")}:${String(ts.getMinutes()).padStart(2, "0")}` : "—";
                  const isFirstStage = earliestTime !== null && getTime(h.timestamp) === earliestTime;
                  return (
                    <Paper key={idx} sx={{ p: 1.5, backgroundColor: "#f9f9f9" }}>
<Typography variant="body2"><strong>الحالة:</strong> {renameStatus(h.status, order)}</Typography>
                      {isFirstStage && (
                        <Typography variant="body2"><strong>بواسطة:</strong> {getDisplayName(h.by || h.updatedBy || "غير معروف")}</Typography>
                      )}
                      <Typography variant="body2"><strong>الوقت:</strong> {timestamp}</Typography>
                    </Paper>
                  );
                  });
                })()}
              </Box>
 
            </AccordionDetails>
          </Accordion>
 </Box>
        );
      })}
 </>
)}
   


      {/* البوب أب لتعديل الطلب */}
      <Dialog open={!!editingOrder} onClose={() => setEditingOrder(null)} fullWidth>
        <DialogTitle>تعديل الطلب</DialogTitle>
        <DialogContent>
          <TextField
            label="اسم الزبون"
            fullWidth
            margin="normal"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
          />
          <TextField
            label="السعر"
            fullWidth
            margin="normal"
            type="number"
            value={editPrice}
            onChange={(e) => setEditPrice(e.target.value)}
          />
          <TextField
            label="الملاحظات"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            value={editNote}
            onChange={(e) => setEditNote(e.target.value)}
          />
          {/* 🖼️ الصور المرفوعة سابقًا */}
{existingFeedbackImages.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">
      📷 صور الفيدباك الحالية:
    </Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {existingFeedbackImages.map((url, index) => (
        <Box key={index} position="relative">
          <img
            src={url}
            alt="feedback"
            style={{
              width: 90,
              height: 90,
              objectFit: "cover",
              borderRadius: 8,
              border: "1px solid #ccc",
              cursor: "pointer",
            }}
            onClick={() => setPreviewFile({ url })}
          />

          {/* ❌ زر حذف الصورة */}
          <Button
            size="small"
            color="error"
            sx={{
              position: "absolute",
              top: -6,
              right: -6,
              minWidth: 24,
              height: 24,
              borderRadius: "50%",
              padding: 0,
            }}
            onClick={() =>
              setExistingFeedbackImages(
                existingFeedbackImages.filter((_, i) => i !== index)
              )
            }
          >
            ✕
          </Button>
        </Box>
      ))}
    </Box>
  </Box>
)}

        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditingOrder(null)}>إلغاء</Button>
          <Button
  variant="contained"
  onClick={async () => {
    setLoading(true);
    await handleUpdate();
    setLoading(false);
  }}
>
  {loading ? "⏳ جاري الحفظ..." : "حفظ التعديلات"}
</Button>

        </DialogActions>
      </Dialog>
      <Dialog open={openFeedbackDialog} onClose={() => setOpenFeedbackDialog(false)}>
<DialogTitle>
  {isEditingFeedback
    ? "✏️ تعديل فيدباك الزبون"
    : "📩 إضافة فيدباك الزبون"}
</DialogTitle>
  <DialogContent>
    <Box display="flex" flexDirection="column" gap={2} mt={1}>
      <Typography fontWeight="bold">اختر نوع الفيدباك:</Typography>
      <Stack direction="row" spacing={2}>
        <Button
          variant={feedbackType === "ايجابي" ? "contained" : "outlined"}
          color="success"
          onClick={() => setFeedbackType("ايجابي")}
        >
          👍 إيجابي
        </Button>
        <Button
          variant={feedbackType === "سلبي" ? "contained" : "outlined"}
          color="error"
          onClick={() => setFeedbackType("سلبي")}
        >
          👎 سلبي
        </Button>
      </Stack>

      {/* إظهار الحقول فقط بعد اختيار النوع */}
      {feedbackType && (
           <>
   
            {feedbackType === "سلبي" && (
             <Box
               sx={{
                 p: 1.5,
                 border: "1px solid #f44336",
                 borderRadius: 2,
                 background: "#fff5f5",
               }}
             >
               <Typography fontWeight="bold" color="error">
                 هل الزبون رفض اللوحة ورجعها؟ (أرشفة)
               </Typography>
           
               <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
                 <Button
                   variant={negativeArchive ? "contained" : "outlined"}
                   color="error"
                   onClick={() => setNegativeArchive(true)}
                 >
                   نعم (أرشفة)
                 </Button>
           
                 <Button
                   variant={!negativeArchive ? "contained" : "outlined"}
                   color="inherit"
                   onClick={() => setNegativeArchive(false)}
                 >
                   لا (فيدباك سلبي فقط)
                 </Button>
               </Stack>
             </Box>
           )}
             <TextField
               label="ملاحظات الزبون"
               multiline
               fullWidth
               rows={3}
               value={feedbackNote}
               onChange={(e) => setFeedbackNote(e.target.value)}
             />
             {feedbackType === "سلبي" && (
     <Box mt={2}>
       <Typography fontWeight="bold" mb={1}>
         ⚠️ حدد نوع المشكلة:
       </Typography>
   
       {[
         { key: "frame", label: "مشكلة في الإطار" },
         { key: "printing", label: "مشكلة في الطباعة" },
         { key: "drawing", label: "مشكلة في الرسم" },
         { key: "designer", label: "مشكلة في المصمم" },
         { key: "transport", label: "مشكلة في شركة النقل" },
         { key: "employee", label: "مشكلة في الموظف المصمم" },
         { key: "delay", label: "تأخير في الوقت" },
       ].map((item) => (
         <Box key={item.key} mb={1}>
           <Stack direction="row" alignItems="center" spacing={1}>
             <input
               type="checkbox"
               checked={negativeIssues[item.key].checked}
               onChange={(e) =>
                 setNegativeIssues((prev) => ({
                   ...prev,
                   [item.key]: {
                     ...prev[item.key],
                     checked: e.target.checked,
                   },
                 }))
               }
             />
             <Typography>{item.label}</Typography>
           </Stack>
   
           {negativeIssues[item.key].checked && (
             <TextField
               fullWidth
               size="small"
               sx={{ mt: 1 }}
               placeholder="اكتب تفاصيل المشكلة..."
               value={negativeIssues[item.key].note}
               onChange={(e) =>
                 setNegativeIssues((prev) => ({
                   ...prev,
                   [item.key]: {
                     ...prev[item.key],
                     note: e.target.value,
                   },
                 }))
               }
             />
           )}
         </Box>
       ))}
     </Box>
   )}

{/* 🖼️ الصور الحالية مع زر حذف */}
{existingFeedbackImages.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">
      📷 صور الفيدباك الحالية:
    </Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {existingFeedbackImages.map((url, index) => (
        <Box key={index} position="relative">
          <img
            src={url}
            alt="feedback"
            style={{
              width: 90,
              height: 90,
              objectFit: "cover",
              borderRadius: 8,
              border: "1px solid #ccc",
            }}
          />

          <Button
            size="small"
            color="error"
            sx={{
              position: "absolute",
              top: -6,
              right: -6,
              minWidth: 22,
              height: 22,
              borderRadius: "50%",
              padding: 0,
              fontSize: 12,
            }}
            onClick={() =>
              setExistingFeedbackImages(
                existingFeedbackImages.filter((_, i) => i !== index)
              )
            }
          >
            ✕
          </Button>
        </Box>
      ))}
    </Box>
  </Box>
)}

          <Button
            variant="outlined"
            component="label"
          >
            📤 رفع صورة
      <input
  type="file"
  accept="image/*"
  multiple
  hidden
  onChange={(e) => {
    const files = Array.from(e.target.files);
    setFeedbackImages((prev) => [...prev, ...files]);
  }}
/>


          </Button>
{/* 🆕 معاينة الصور الجديدة قبل الحفظ */}
{feedbackImages.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">
      📤 صور جديدة (لم تُحفظ بعد):
    </Typography>

    <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
      {feedbackImages.map((file, index) => (
        <Box key={index} position="relative">
          <img
            src={URL.createObjectURL(file)}
            alt="new-feedback"
            style={{
              width: 90,
              height: 90,
              objectFit: "cover",
              borderRadius: 8,
              border: "1px solid #1976d2",
            }}
          />

          {/* ❌ حذف الصورة الجديدة */}
          <Button
            size="small"
            color="error"
            sx={{
              position: "absolute",
              top: -6,
              right: -6,
              minWidth: 22,
              height: 22,
              borderRadius: "50%",
              padding: 0,
              fontSize: 12,
            }}
            onClick={() =>
              setFeedbackImages(
                feedbackImages.filter((_, i) => i !== index)
              )
            }
          >
            ✕
          </Button>
        </Box>
      ))}
    </Box>
  </Box>
)}

          {feedbackImage && (
            <Typography color="textSecondary">
              تم اختيار الصورة: {feedbackImage.name}
            </Typography>
          )}
        </>
      )}
    </Box>
  </DialogContent>
  <DialogActions>
    {/* 🆕 Dialog رفع صور التركيب */}


    <Button onClick={() => setOpenFeedbackDialog(false)}>إلغاء</Button>
    {!feedbackImage && currentFeedbackOrder?.feedback?.image && (
  <Box mt={2}>
    <Typography fontWeight="bold" fontSize={14}>الصورة المرفوعة سابقاً:</Typography>
    <img
      src={currentFeedbackOrder.feedback.image}
      alt="feedback"
      style={{ maxWidth: "100%", maxHeight: 250, borderRadius: 8 }}
    />
  </Box>
)}

  <Button
  variant="contained"
  onClick={handleSubmitFeedback}
 disabled={
  savingFeedback ||
  !feedbackType ||
  !feedbackNote ||
  (feedbackType === "سلبي" &&
    existingFeedbackImages.length === 0 &&
    feedbackImages.length === 0)
}

>
  {savingFeedback ? "⏳ جاري الحفظ..." : "حفظ الفيدباك"}
</Button>

  </DialogActions>
</Dialog>
{/* 📷 Dialog رفع صور التركيب */}
<Dialog
  open={openInstallationDialog}
  onClose={() => setOpenInstallationDialog(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>📷 رفع صور التركيب</DialogTitle>

  <DialogContent>
    <Typography sx={{ mb: 2 }}>
      يرجى رفع صور أو فيديو تركيب اللوحة
    </Typography>

    <Button variant="outlined" component="label">
      اختيار ملفات
      <input
        type="file"
        accept="image/*,video/*"
        multiple
        hidden
        onChange={(e) => appendPickedFiles(e, setInstallationFiles)}
      />
    </Button>

    <Typography sx={{ mt: 1 }}>
      {installationFiles.length} ملف مختار
    </Typography>
    <Typography sx={{ mt: 0.5, fontSize: 13, color: "gray" }}>
  📷 صور: {installationFiles.filter(f => f.type.startsWith("image")).length}
  {" | "}
  🎥 فيديو: {installationFiles.filter(f => f.type.startsWith("video")).length}
</Typography>
    <UploadPreview files={installationFiles} onChange={setInstallationFiles} />

  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenInstallationDialog(false)}>
      إلغاء
    </Button>

   <Button
  variant="contained"
  disabled={installationFiles.length === 0 || uploadingInstallation}
  onClick={handleUploadInstallation}
>
  {uploadingInstallation ? "⏳ جاري الرفع..." : "حفظ"}
</Button>

  </DialogActions>
</Dialog>
{/* 🔍 Dialog معاينة صورة التركيب */}
<Dialog
  open={!!previewFile}
  onClose={() => setPreviewFile(null)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>📷 معاينة الصورة</DialogTitle>
  <DialogContent
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    {previewFile && (
      <img
        src={previewFile.url}
        alt="preview"
        style={{
          maxWidth: "100%",
          maxHeight: "80vh",
          objectFit: "contain",
        }}
      />
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setPreviewFile(null)}>إغلاق</Button>
  </DialogActions>
</Dialog>
<Dialog
  open={openCancelDialog}
  onClose={() => setOpenCancelDialog(false)}
  fullWidth
>
  <DialogTitle>❌ إلغاء الطلب</DialogTitle>
  <DialogContent>
    <TextField
      label="سبب الإلغاء"
      fullWidth
      multiline
      rows={3}
      value={cancelReason}
      onChange={(e) => setCancelReason(e.target.value)}
      sx={{ mt: 2 }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenCancelDialog(false)}>
      رجوع
    </Button>
    <Button
      variant="contained"
      color="error"
      onClick={handleCancelOrder}
      disabled={!cancelReason.trim()}
    >
      حفظ الإلغاء
    </Button>
  </DialogActions>
</Dialog>

    </Container>
  );
};

export default MaysaDashboard;
